var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 188,
    height: 82.74,
    viewBox: "0 0 188 82.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -0.036)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.036 54.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.079,170.759l-3.04-5.186c-.143,0-.358.036-.644.036H3.462v5.15H.1V153.2H7.431a7.886,7.886,0,0,1,5.257,1.574,5.48,5.48,0,0,1,1.86,4.47,6.468,6.468,0,0,1-.894,3.5,5.634,5.634,0,0,1-2.611,2.181l3.862,5.829Zm-7.617-8.118h3.97a4.441,4.441,0,0,0,2.9-.823,2.942,2.942,0,0,0,1-2.468,2.842,2.842,0,0,0-1-2.4,4.579,4.579,0,0,0-2.9-.787H3.462Z",
    transform: "translate(-0.1 -153.2)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51,153.2h3.362v17.559H51Z",
    transform: "translate(-32.797 -153.2)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67,153.2h3.612l5.15,13.8,5.221-13.8h3.469l-7.009,17.559H73.974Z",
    transform: "translate(-43.075 -153.2)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.5,153.2h12.874v2.932h-9.513v4.327h8.511v2.932h-8.511v4.4h9.8v2.932H122.5V153.2Z",
    transform: "translate(-78.727 -153.2)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.315,170.759l-3.04-5.186c-.143,0-.358.036-.644.036h-3.97v5.15H169.3V153.2h7.331a7.886,7.886,0,0,1,5.257,1.574,5.48,5.48,0,0,1,1.86,4.47,6.468,6.468,0,0,1-.894,3.5,5.634,5.634,0,0,1-2.611,2.181l3.862,5.829Zm-7.617-8.118h3.97a4.441,4.441,0,0,0,2.9-.823,2.942,2.942,0,0,0,1-2.468,2.842,2.842,0,0,0-1-2.4,4.579,4.579,0,0,0-2.9-.787H172.7Z",
    transform: "translate(-108.791 -153.2)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.7,154.773a5.568,5.568,0,0,1,1.824,4.47,6.036,6.036,0,0,1-1.824,4.685,7.342,7.342,0,0,1-5.114,1.681h-3.827v5.15H220.4V153.2h7.188A7.67,7.67,0,0,1,232.7,154.773Zm-2.4,7.009a2.942,2.942,0,0,0,1-2.468,2.842,2.842,0,0,0-1-2.4,4.622,4.622,0,0,0-2.932-.787h-3.648v6.509h3.648A4.414,4.414,0,0,0,230.306,161.783Z",
    transform: "translate(-141.617 -153.2)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.827,170.759l-1.538-3.719h-8.583l-1.538,3.719H258.7l7.689-17.559h3.469l7.617,17.559Zm-8.9-6.616h6.187l-3.076-7.367Z",
    transform: "translate(-166.22 -153.2)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.615,170.759l-3.04-5.186c-.143,0-.358.036-.644.036h-3.97v5.15H317.6V153.2h7.331a7.886,7.886,0,0,1,5.257,1.574,5.48,5.48,0,0,1,1.86,4.47,6.469,6.469,0,0,1-.894,3.5,5.634,5.634,0,0,1-2.611,2.181l3.862,5.829Zm-7.653-8.118h3.97a4.441,4.441,0,0,0,2.9-.823,2.942,2.942,0,0,0,1-2.468,2.841,2.841,0,0,0-1-2.4,4.578,4.578,0,0,0-2.9-.787h-3.97Z",
    transform: "translate(-204.056 -153.2)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.264,170.823h-4.041l-5.507-7.51-2.754,3.04v4.506H368.6V153.3h3.362v8.762L379.9,153.3h3.97l-6.759,7.438Z",
    transform: "translate(-236.818 -153.264)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 78.52)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,220.093a1.323,1.323,0,0,1,.429,1.037A1.428,1.428,0,0,1,3,222.239a1.682,1.682,0,0,1-1.216.429H1.073v1.109H0V219.7H1.788A2.053,2.053,0,0,1,3,220.093Zm-.751,1.574a.694.694,0,0,0,0-.93.7.7,0,0,0-.5-.143H1.073v1.252h.679A1.044,1.044,0,0,0,2.253,221.667Z",
    transform: "translate(0 -219.628)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.468,223.777l-.608-1.109h-.787v1.109H32V219.7h1.824a1.867,1.867,0,0,1,1.252.358,1.323,1.323,0,0,1,.429,1.037,1.705,1.705,0,0,1-.179.787,1.29,1.29,0,0,1-.536.536l.858,1.323h-1.18Zm-1.395-1.967h.787a.707.707,0,0,0,.5-.179.694.694,0,0,0,0-.93.7.7,0,0,0-.5-.143h-.787Z",
    transform: "translate(-20.556 -219.628)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.39,219.886a1.987,1.987,0,0,1,.787.751,2.155,2.155,0,0,1,0,2.146,1.987,1.987,0,0,1-.787.751,2.323,2.323,0,0,1-1.109.286,2.22,2.22,0,0,1-1.109-.286,1.987,1.987,0,0,1-.787-.751,2.155,2.155,0,0,1,0-2.146,1.988,1.988,0,0,1,.787-.751,2.323,2.323,0,0,1,1.109-.286A2.057,2.057,0,0,1,67.39,219.886Zm-1.681.751a.91.91,0,0,0-.393.429,1.364,1.364,0,0,0,0,1.216,1.524,1.524,0,0,0,.393.429,1.049,1.049,0,0,0,.572.143.862.862,0,0,0,.536-.143,1.136,1.136,0,0,0,.393-.429,1.364,1.364,0,0,0,0-1.216,1.137,1.137,0,0,0-.393-.429,1.009,1.009,0,0,0-.536-.143A1.5,1.5,0,0,0,65.709,220.637Z",
    transform: "translate(-41.177 -219.564)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.9,220.029a1.323,1.323,0,0,1,.429,1.037,1.428,1.428,0,0,1-.429,1.109,1.772,1.772,0,0,1-1.216.393h-.715v1.109H98.9V219.6h1.788A2.225,2.225,0,0,1,101.9,220.029Zm-.751,1.574a.694.694,0,0,0,0-.93.7.7,0,0,0-.5-.143h-.679v1.252h.679A.92.92,0,0,0,101.153,221.6Z",
    transform: "translate(-63.532 -219.564)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131,219.8h3.219v.858h-2.146v.751H134v.858h-1.931v.751h2.217v.858H131Z",
    transform: "translate(-84.152 -219.693)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.468,223.777l-.608-1.109h-.787v1.109H163V219.7h1.824a1.867,1.867,0,0,1,1.252.358,1.323,1.323,0,0,1,.429,1.037,1.7,1.7,0,0,1-.179.787,1.29,1.29,0,0,1-.536.536l.858,1.323h-1.18Zm-1.359-1.967h.787a.707.707,0,0,0,.5-.179.694.694,0,0,0,0-.93.7.7,0,0,0-.5-.143h-.787Z",
    transform: "translate(-104.708 -219.628)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.736,219.8H198.2v.858h-1.216v3.183h-1.073v-3.183H194.7V219.8Z",
    transform: "translate(-125.072 -219.693)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.8,219.8h1.073v4.077H226.8Z",
    transform: "translate(-145.692 -219.693)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.1,219.8h3.219v.858h-2.146v.751H256.1v.858h-1.931v.751h2.217v.858h-3.254V219.8Z",
    transform: "translate(-162.587 -219.693)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.825,220.5a2.412,2.412,0,0,0-.608-.107.714.714,0,0,0-.322.072.216.216,0,0,0-.107.215.255.255,0,0,0,.107.215.577.577,0,0,0,.25.143c.107.036.25.072.429.143.286.071.5.179.715.25a1.162,1.162,0,0,1,.465.358,1,1,0,0,1,.215.644,1.03,1.03,0,0,1-.215.679,1.422,1.422,0,0,1-.572.429,2.1,2.1,0,0,1-.823.143,3.285,3.285,0,0,1-1-.179,2.581,2.581,0,0,1-.858-.5l.429-.823a2.925,2.925,0,0,0,.715.429,2.261,2.261,0,0,0,.751.179.9.9,0,0,0,.358-.072.27.27,0,0,0,.143-.25.216.216,0,0,0-.107-.215.577.577,0,0,0-.25-.143c-.107-.036-.25-.072-.429-.143a2.466,2.466,0,0,1-.679-.25,1.474,1.474,0,0,1-.465-.358.868.868,0,0,1-.179-.644,1,1,0,0,1,.215-.644,1.422,1.422,0,0,1,.572-.429,2.164,2.164,0,0,1,.858-.143,3.527,3.527,0,0,1,.858.107,2.386,2.386,0,0,1,.751.322l-.393.858C287.289,220.68,287.075,220.573,286.825,220.5Z",
    transform: "translate(-182.758 -219.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.4,219.8h1.073v3.147h1.717v.894H341.4Z",
    transform: "translate(-219.309 -219.693)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.136,219.8H372.6v.858h-1.216v3.183h-1.073v-3.183H369.1V219.8Z",
    transform: "translate(-237.103 -219.693)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404,220.05a1.81,1.81,0,0,1,.751.715,2.155,2.155,0,0,1,0,2.146,1.707,1.707,0,0,1-.787.715,2.347,2.347,0,0,1-1.144.25H401.1V219.8h1.752A2.347,2.347,0,0,1,404,220.05Zm-.536,2.789a1.05,1.05,0,0,0,.358-.429,1.682,1.682,0,0,0,.143-.608,1.175,1.175,0,0,0-.143-.608,1.137,1.137,0,0,0-.393-.429,1.049,1.049,0,0,0-.572-.143h-.679v2.36h.715A1.049,1.049,0,0,0,403.46,222.84Z",
    transform: "translate(-257.659 -219.693)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M374.063,5.316h0c-26.213,8.476-40.125-11.623-66.338-3.147Q300.913,17.994,294.1,33.854c26.178-8.44,40.125,11.587,66.3,3.183L341.234,82.7h2.289l33.4-76.173Z",
    transform: "translate(-188.924 0)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.575,40.222a10.809,10.809,0,0,0,5.686-1.109,11.693,11.693,0,0,1-.072,5.15c.572.072,1.18.107,1.788.143,2.289-15.27-16.307-17.881-16.307-17.881s14.162.179,17.023,10.586a7.211,7.211,0,0,0,.823-6.759c-1.86-5.615-9.513-7.188-15.878-7.9-6.366-.751-8.726-4.148-8.726-4.148C369.338,34.393,379.673,39.9,386.575,40.222Z",
    transform: "translate(-238.163 -11.732)",
    fill: "#a2d45e",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLogo);
export default __webpack_public_path__ + "static/media/FooterLogo.5a688597f1c8872c57942d4b0063d196.svg";
export { ForwardRef as ReactComponent };